import React from "react";
import { FiMapPin, FiPhone, FiClock } from "react-icons/fi";
import { gradient_primary } from "./../../assets/data/colors";

const details = [
    {
        icon: <FiMapPin size={18} />,
        label: "Location",
        value: "Zakho, Duhok",
        sub: "Kurdistan Region, Iraq",
    },
    {
        icon: <FiPhone size={18} />,
        label: "Phone",
        value: "0750 807 8879",
        sub: "Call us anytime",
        href: "tel:07508078879",
    },
    {
        icon: <FiClock size={18} />,
        label: "Working Hours",
        value: "Sat – Thu, 9am – 10pm",
        sub: "We're happy to meet",
    },
];

// visit us component for contact page
const VisitUs = () => {
    return (
        <div className="w-full">
            <div className="mb-6">
                <p className="text-xs font-semibold tracking-[2.5px] uppercase text-[#378ADD] mb-1">In Person</p>
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Come visit us</h3>
                <p className="text-sm text-gray-400 font-light mt-1">Call ahead to book an appointment — we'd love to meet over coffee.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
                {details.map((item) => (
                    <div key={item.label} className="p-5 rounded-xl border border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/40 flex flex-col gap-3">
                        <div className="w-10 h-10 rounded-xl flex items-center justify-center text-[#e2b04a]" style={{ background: gradient_primary }}>
                            {item.icon}
                        </div>
                        <div>
                            <p className="text-xs font-semibold tracking-wider uppercase text-gray-400 mb-1">{item.label}</p>
                            {item.href ? (
                                <a href={item.href} className="text-base font-semibold text-gray-900 dark:text-white hover:text-[#378ADD] transition-colors">
                                    {item.value}
                                </a>
                            ) : (
                                <p className="text-base font-semibold text-gray-900 dark:text-white">{item.value}</p>
                            )}
                            <p className="text-xs text-gray-400 font-light mt-0.5">{item.sub}</p>
                        </div>
                    </div>
                ))}
            </div>

            <div className="rounded-xl border border-gray-100 dark:border-gray-700 overflow-hidden bg-gray-50 dark:bg-gray-800/40 h-36 flex items-center justify-center gap-3 text-gray-300 dark:text-gray-600">
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1943.7197323988373!2d42.68196404949956!3d37.163546283573275!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40091995b3f7a209%3A0x1f7db4f457a7fa0b!2sAzadi%20clinic!5e0!3m2!1sen!2siq!4v1778247051236!5m2!1sen!2siq" title="The Light" className="w-full h-full" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </div>
    );
};
export default VisitUs;